import type { ExtensionConfig } from '@goto/shell'
import { getFeatureFlag, getLaunchDarklyFlag } from '../helpers/shell-helpers'
import { LaunchDarklyVariations, UnleashFlags } from '../models/feature-flag.models'
import { getOOSArtifactUrl } from '../helpers/experience-helpers'
import { createIntegrationConfigIfFlagEnabled } from '../helpers/integration-helpers'

const integrationFlagSuffix = 'oos-meeting-meet-now'

const getExtensionVersion = () => {
  const useUnleash = getFeatureFlag(UnleashFlags.OOS_USE_UNLEASH, false)

  return useUnleash
    ? getFeatureFlag(UnleashFlags.OOS_MEET_NOW_VERSION, 'release')
    : getLaunchDarklyFlag(LaunchDarklyVariations.OOS_MEET_NOW_VERSION)
}

const extensionConfig: ExtensionConfig = {
  id: '@goto/oos-meeting-meet-now',
  get url() {
    const version = getExtensionVersion()
    return new URL(getOOSArtifactUrl('meeting-meet-now-extension', version))
  },
  get integrationConfig() {
    return createIntegrationConfigIfFlagEnabled(integrationFlagSuffix)
  },
}

export default extensionConfig
